import { Injectable } from '@angular/core'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'
import { FilterEntity } from '@awork/_shared/models/filters.model'
import { syncStore } from '@awork/core/state/signal-store/sync-store'

@Injectable({ providedIn: 'root' })
export class EntityFilterStore extends EntitySignalStore<FilterEntity> {
  constructor() {
    super({
      name: 'entityFilter',
      entityConstructor: filter => new FilterEntity(filter)
    })
  }

  /**
   * Synchronize the store with the data fetched from the API
   * Add new, update existing and remove non-existing entity filters
   * @param {FilterEntity[]} filters - Filters from API
   * @param {FilterEntity[]} storedFilters - Current filters in store
   */
  sync(filters: FilterEntity[], storedFilters: FilterEntity[]): void {
    syncStore(filters, storedFilters, this)
  }
}
